import {
    css, keyframes
} from '@emotion/react';
import styled from '@emotion/styled';

import {
    DEFAULT_TOTAL_DOTS, LoaderDotsProps
} from './loader-dots';

const loadingKeyframes = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.3);
    background: #59CD90;
  }
  25% {
    opacity: 1;
    transform: scale(1.8);
    background: #0072BB;
  }
  50% {
    opacity: 0;
    transform: scale(0.3);
    background: #FE4A49;
  }
  75% {
    opacity: 1;
    transform: scale(1.8);
    background: #FED766;
  }
  100% {
    opacity: 0;
  }
`;
const createAnimation = ({
    totalDots = DEFAULT_TOTAL_DOTS, duration
}: LoaderDotsProps) => {
    return Array.from(Array(totalDots)).map(
        (_, index) => {
            const delay = totalDots / ((totalDots + 1) - index);

            return css`
              div:nth-of-type(${index + 1}) {
                  animation-duration: ${duration}s;
                  animation-delay: ${delay}s;
                  animation-name:${loadingKeyframes};
                  animation-timing-function: linear;
                  animation-iteration-count: infinite;
              }
            `;
        });
};

export const LoaderDotsAnimation = styled.div<LoaderDotsProps>`
  position: relative;
  display: flex;

  div {
    border-radius: 50%;

    ${props => props.dotSize ? `
        min-height: ${props.dotSize}px;
        min-width: ${props.dotSize}px;
    ` : null}

    ${props => props.dotSpacing ? `
        margin-right: ${props.dotSpacing}px;
        &:last-child {
            margin-right: 0 !important;
        }
    ` : null}
  }

  ${createAnimation}
`;
